import React from "react";
import { useQuery } from "@apollo/react-hooks";
import * as S from "./styles";
import { IProps } from "./types";
import { MyAccountMenu, MyAccountMain } from "@organisms";
import { Container, Row, Col } from "react-bootstrap";
import { ME_FOR_ACCOUNT_PAGE } from "./queries";
import { Loading, BreadCrumb } from "@atoms";
import { meForAccountPage } from "@components/pages/AccountPage/__generated__/meForAccountPage";
import { getDBIdFromGraphqlId } from "@utils";
import { DeviceContext, deviceType } from "@providers";
import { useAlert } from "react-alert";

const AccountPage: React.FC<IProps> = ({}: IProps) => {
  const alert = useAlert();
  const {data, error, loading} = useQuery<meForAccountPage>(ME_FOR_ACCOUNT_PAGE, {
    fetchPolicy: "network-only",
  });
  const isMobile = React.useContext<deviceType>(DeviceContext).isMobile;

  const breadCrumbData = [
    {
      name: "My Account"
    }
  ]

  return data && (
    <S.Wrapper>
      <BreadCrumb
        data={breadCrumbData}
      />
      <S.Title>My Account</S.Title>
      {
        isMobile ?
        <>
          <hr/>
          <Container>
            <Row>
              <Col md={9}>
                <MyAccountMain
                  firstName={data?.me?.firstName}
                  skinType={data?.me?.skinType}
                  skinConcern={data?.me?.skinConcern}
                  activeOrders={data?.orders?.totalCount}
                  pendingReviews={
                    data?.me?.notReviewedProducts?.filter((p, idx) => {
                      const dbId = getDBIdFromGraphqlId(p.productType.id, "ProductType");
                      return dbId in [1, 2, 4];
                    }).length
                  }
                  availablePoints={data?.me?.point?.availableAmount}
                />
              </Col>
              <Col md={3}>
                <MyAccountMenu/>
              </Col>
            </Row>
          </Container>
        </>
        :
        <>
          <hr/>
          <Container>
            <Row>
              <Col md={3}>
                <MyAccountMenu/>
              </Col>
              <Col md={9}>
                <MyAccountMain
                  firstName={data?.me?.firstName}
                  skinType={data?.me?.skinType}
                  skinConcern={data?.me?.skinConcern}
                  activeOrders={data?.orders?.totalCount}
                  pendingReviews={
                    data?.me?.notReviewedProducts?.filter((p, idx) => {
                      const dbId = getDBIdFromGraphqlId(p.productType.id, "ProductType");
                      return dbId in [1, 2, 4];
                    }).length
                  }
                  availablePoints={data?.me?.point?.availableAmount}
                />
              </Col>
            </Row>
          </Container>
        </>
      }
      
    </S.Wrapper>
  ) || <Loading/>;
};

export { AccountPage }